import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import {
  ControlledDatePicker,
  ControlledSelect
} from 'components/shared/ControlledFields';
import { useGetAccountGroupsOptions } from '../../../../queries';
import { useFieldArrayContext } from 'components/shared/CRUD/components/InnerPage/hooks/useFieldArrayContext';
import useFindIndexFromFieldsArray from 'components/shared/CRUD/hooks/useFindIndexFromFieldsArray';
import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';
import Box from '@mui/material/Box';

const getLastAddedFieldId = (fields: FieldArrayWithId[]) =>
  fields.slice(-1)[0]?.id;

export const AccountGroupSection = ({ rowId }) => {
  const { data: options } = useGetAccountGroupsOptions();
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { fields } = useFieldArrayContext();
  const fieldIndex = useFindIndexFromFieldsArray(
    rowId ?? getLastAddedFieldId(fields),
    fields
  );

  return (
    <>
      <Box mb={2.5} width={'100%'}>
        <ControlledSelect
          name={`groups.${fieldIndex}.groupId`}
          hasClearButton
          control={control}
          variant="outlined"
          options={options ?? []}
          label={t('name')}
        />
      </Box>
      <Box mb={2.5} width={'100%'}>
        <ControlledDatePicker
          control={control}
          name={`groups.${fieldIndex}.valid.from`}
          label={t('from')}
          fullWidth
        />
      </Box>
      <Box mb={2.5} width={'100%'}>
        <ControlledDatePicker
          control={control}
          name={`groups.${fieldIndex}.valid.to`}
          label={t('to')}
          fullWidth
        />
      </Box>
    </>
  );
};
